import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Login } from 'dsilo-ui-components';

import { loginRedirect } from './msalService';
import PreAppLoading from '../../components/PreAppLoading/PreAppLoading';

import { checkEmailForAad, emptyPrevPath, loadApps, resendVerifyEmail, submitLogin, checkEmailForLLSE, checkEmailFromUER } from '../../store/actions';

import dsiloLogo from '../../images/logo.png';

const LoginComponent = props => {
	const secretKey = process.env.REACT_APP_CRYPT_SECRET_KEY || '';

	// // SSO load, when `llse` found in localStorage
	// const llse = localStorage.getItem('llse');
	// const isSsoLogin = localStorage.getItem('isSsoLogin');
	// const userEmailReport = localStorage.getItem('userEmailReport');

	// const { isCheckEmailLLSELoading, emailCheckData, isCheckEmailLLSEComplete } = props.login

	// useEffect(() => {
	// 	console.log("llse found in localStorage, triggering SSO", llse);
	// 	if (llse
	// 		// && !isSsoLogin 
	// 		&& !isCheckEmailLLSEComplete && !userEmailReport && !props.user?.manualLogout) {
	// 		console.log("llse found in localStorage, triggering SSO");
	// 		props.checkEmailForLLSE({ llse })
	// 	} else if (!isCheckEmailLLSEComplete && userEmailReport
	// 		// && !isSsoLogin 
	// 		&& !props.user?.manualLogout) {
	// 		console.log("userEmailReport found in localStorage, triggering SSO");
	// 		props.checkEmailFromUER({ userEmailReport })
	// 	}
	// }, []);

	// console.log("llse =====", llse)
	// console.log("isCheckEmailLLSELoading =====", isCheckEmailLLSELoading)
	// console.log("isCheckEmailLLSEComplete =====", isCheckEmailLLSEComplete)
	// console.log("emailCheckData?.isCheckEmailLLSEComplete =====", emailCheckData?.isCheckEmailLLSEComplete)
	// console.log("isSsoLogin =====", !isSsoLogin)

	return (
		<div className="login-ciep" >
			<Login
				appLogo={dsiloLogo}
				handleLogin={(data) => { props.submitLogin(data) }}
				handleVerifyEmail={(data) => { props.resendVerifyEmail(data) }}
				checkEmailForAad={(data) => props?.checkEmailForAad(data)}
				loginRedirect={loginRedirect}
				hidePassword={true}
				login={props.login}
				subTitle={"ProcureGPT&trade; - AI Platform"}
				secretKey={secretKey}
			/>
		</div>
	);
};

const mapDispatchToProps = {
	checkEmailForAad,
	submitLogin,
	resendVerifyEmail,
	loadApps,
	emptyPrevPath,
	checkEmailForLLSE,
	checkEmailFromUER
};

const mapStateToProps = state => {
	return {
		login: state.login,
		apps: state.app,
		user: state.user,
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponent));
